import * as predictionScheduleActions from '../actions/prediction-schedule.actions';
import { PagedEntity } from './index';

export interface PredictionScheduleState {
  pagedEntity: PagedEntity;
  error: any;
}

const initialState = {
  pagedEntity: null,
  error: null,
};

export const predictionScheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case predictionScheduleActions.GET_PREDICTION_SCHEDULE:
      return {
        ...state,
        pagedEntity: null
      };

    case predictionScheduleActions.GET_PREDICTION_SCHEDULE_SUCCESS:
      return {
        ...state,
        error: null,
        pagedEntity: action.payload,
      };
    case predictionScheduleActions.GET_PREDICTION_SCHEDULE_FAIL:
      return {
        ...state,
        error: action.payload,
        pagedEntity: null
      };
    case predictionScheduleActions.CLEAR_PREDICTION_SCHEDULE:
      return {
        ...state,
        error: null,
        pagedEntity: null
      };
    default:
      return state;
  }
};

export const getPredictionSchedule = (state: PredictionScheduleState) => state.pagedEntity;
